import { usePhone } from '@/state/phone';
import { formatRelativeTime } from '@/lib/time';
import { cn } from '@/lib/cn';

export function ThreadList() {
  const contacts = usePhone((s) => s.contacts);
  const messages = usePhone((s) => s.messages);
  const open = usePhone((s) => s.openThread);

  const threads = Object.values(contacts)
    .map((contact) => {
      const threadMsgs = messages.filter((m) => m.threadId === contact.id);
      const lastMessage = threadMsgs[threadMsgs.length - 1];
      const unreadCount = threadMsgs.filter((m) => !m.fromSelf && !m.read).length;
      return { contact, lastMessage, unreadCount };
    })
    .sort((a, b) => {
      if (a.unreadCount !== b.unreadCount) return b.unreadCount - a.unreadCount;
      return (b.lastMessage?.timestamp ?? 0) - (a.lastMessage?.timestamp ?? 0);
    });

  return (
    <div className="flex h-full flex-col">
      <header className="flex items-center justify-between border-b border-[var(--border-subtle)] bg-[var(--bg-surface)] px-4 py-3">
        <span className="text-mono-md font-bold text-[var(--text-primary)]">Phone</span>
        <span className="text-mono-xs text-[var(--text-muted)]">
          {threads.reduce((acc, t) => acc + t.unreadCount, 0)} unread
        </span>
      </header>
      <div className="flex-1 overflow-y-auto">
        {threads.map(({ contact, lastMessage, unreadCount }) => (
          <button
            key={contact.id}
            onClick={() => open(contact.id)}
            className={cn(
              'flex w-full items-start gap-3 border-b border-[var(--border-subtle)] px-4 py-3 text-left hover:bg-[var(--bg-elevated)]',
              unreadCount > 0 && 'bg-[var(--bg-surface)]',
            )}
          >
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[var(--bg-elevated)] text-mono-sm font-bold text-[var(--text-primary)]">
              {contact.displayName.charAt(0)}
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-baseline justify-between gap-2">
                <span
                  className={cn(
                    'truncate text-mono-sm',
                    unreadCount > 0
                      ? 'font-bold text-[var(--text-primary)]'
                      : 'text-[var(--text-secondary)]',
                  )}
                >
                  {contact.displayName}
                </span>
                {lastMessage && (
                  <span className="shrink-0 text-mono-xs text-[var(--text-muted)]">
                    {formatRelativeTime(lastMessage.timestamp)}
                  </span>
                )}
              </div>
              {lastMessage && (
                <p className="truncate text-mono-xs text-[var(--text-muted)]">
                  {lastMessage.fromSelf ? 'You: ' : ''}
                  {lastMessage.text}
                </p>
              )}
            </div>
            {unreadCount > 0 && (
              <span className="ml-1 shrink-0 rounded-full bg-[var(--critical)] px-1.5 py-0.5 text-[10px] font-bold text-white">
                {unreadCount}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
